import { APIv4 as API } from 'src/libs/axios';
import { alertError } from 'src/libs/toastify';
import { NomenclatureCategory } from '../../types';

const Messages = {
  FETCH_CATEGORIES: 'Ошибка получения списка категорий номенклатур',
  FETCH_CATEGORY: 'Ошибка получения категории номенклатур',
  CREATE_CATEGORY: 'Ошибка создания категории номенклатур',
  UPDATE_CATEGORY: 'Ошибка обновления категории номенклатур',
  DELETE_CATEGORY: 'Ошибка удаления категории номенклатур',
};

export type NomenclatureCategoryValues = {
  name: string;
};

const BASE_URL = '/back-office/nomenclature-categories';

export const fetchAllNomenclatureCategories = (): Promise<
  NomenclatureCategory[] | void
> =>
  API.get<NomenclatureCategory[]>(BASE_URL)
    .then(({ data }) => data)
    .catch((err) => alertError(err, Messages.FETCH_CATEGORIES));

export const fetchNomenclatureCategory = ({
  id,
}: {
  id: string;
}): Promise<NomenclatureCategory | void> =>
  API.get<NomenclatureCategory>(`${BASE_URL}/${id}`)
    .then(({ data }) => data)
    .catch((err) => alertError(err, Messages.FETCH_CATEGORY));

export const addNomenclatureCategory = (
  data: NomenclatureCategoryValues
): Promise<string> => API.post<string>(BASE_URL, data).then(({ data }) => data);

export const updateNomenclatureCategory = (params: {
  id: string;
  data: NomenclatureCategoryValues;
}): Promise<boolean> =>
  API.put(`${BASE_URL}/${params.id}`, params.data).then(({ data }) =>
    Boolean(data)
  );

export const deleteNomenclatureCategory = ({
  id,
}: {
  id: string;
}): Promise<boolean> =>
  API.delete(`${BASE_URL}/${id}`).then(({ data }) => Boolean(data));
